export const SET_GC_PHASE = "SET_GC_PHASE";
export const SET_GC_FIELD = "SET_GC_FIELD";
export const SET_GC_FORM = "SET_GC_FORM";
export const SET_GC_LOADING = "SET_GC_LOADING";
export const SET_GC_ERROR = "SET_GC_ERROR";
export const SET_GC_FIELD_ERROR = "SET_GC_FIELD_ERROR";
export const CLEAR_GC_FIELD_ERRORS = "CLEAR_GC_FIELD_ERRORS";
export const SET_GC_ACTIVATION = "SET_GC_ACTIVATION";
export const RESET_GC = "RESET_GC";
